import "./static/js/share";
import Vue from "vue";
import App from "./app.vue";
import { createRouter } from "@/route";
import { createStore } from "@/store";
import { sync } from "vuex-router-sync";
import yxAlert from "@/components/yx-alert";
import yxToast from "@/components/yx-toast";
import * as directiyObj from "./utils/directives";
import vueModal from "@/components/vue-modal";
import wx from "@/utils/wxMethods";
import utils from "@/utils/methods";
import { writeCookie, getAccessToken } from "@/api/app";
import DateMethods from "@/utils/DateMethods";
// import VueScroller from 'vue-scroller'
import VueLazyload from "vue-lazyload";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import "@vant/touch-emulator"; // 兼容pc客户端ui库交互

// process.env.NODE_ENV == 'developement' ||
if (location.href.indexOf("debugger") != -1) {
	var vconsole = require("vconsole");
	var v_console = new vconsole();
}

import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);

// // 全局异常捕抓
// Vue.config.errorHandler = (err, vm, info) => {
//     if (process.env.NODE_ENV == 'developement') {
//       var vconsole = require('vconsole');
//       var v_console = new vconsole();
//     }
//     console.log(err)
//     console.log(vm)
//     console.log(info)
// }
// 埋点
import buriedPoint from "@/utils/buriedPoint";
Vue.prototype.$buriedPoint = buriedPoint;

Vue.use(yxAlert);
Vue.use(yxToast);
Vue.use(DateMethods);
// 注册指令
Object.keys(directiyObj).forEach(key => {
	Vue.directive(`${key}`, directiyObj[`${key}`]);
});

// 引入 muse-ui
// import MuseUI from 'muse-ui';
// import 'muse-ui/dist/muse-ui.css';
// Vue.use(MuseUI);

// 晒图需要用到（图片量太大）
Vue.use(VueLazyload, {
	error: "https://resource.oss.yatiku.com/activity/2019Map/image/default.jpg",
	loading: "https://resource.oss.yatiku.com/activity/2019Map/image/default.jpg"
});
// Vue.use(VueScroller);
Vue.use(vueModal);
Vue.use(VueAwesomeSwiper); // 很多页面共带swipei，不可注释

export function createApp() {
	if (navigator.userAgent.toLowerCase().includes("micromessenger"))
		getAccessToken();
	const router = createRouter();
	const store = createStore();
	router.beforeEach((to, from, next) => {
		let urlQuery = utils.getUrlParams(location.search);
		let { query, path } = to;
		store.commit("setRouteQuery", query);
		if (process.env.NODE_ENV != "NODE") {
			document.title = to.meta.title || "千课教育";
		}
		if (query.accId) window.localStorage.accid = query.accId;
		if (
			path.indexOf("miniProgramc") == -1 &&
			!query["authorization"] &&
			!query["slien"]
		) {
			// 新增判断环境 ， 是否微信环境或者浏览器
			if (!navigator.userAgent.toLowerCase().includes("micromessenger")) {
				// window.location.replace(`${location.href}&slien=1`);
				next();
			} else {
				let { code, state } = query;
				if (store.state.userInfo && store.state.userInfo.openid) return next();
				// removeUserData()

				Promise.all([wx.getAccId(urlQuery, code), writeCookie()]).then(
					result => {
						next();
					},
					error => {
						let queryObj = utils.getUrlParams(location.search);
						delete queryObj.code;
						delete queryObj.state;
						const par = utils.filterParams(queryObj);
						// 携带scopeMode=base页面使用静默授权
						const scopeMode =
							queryObj.scopeMode === "base" ? "snsapi_base" : "snsapi_userinfo";
						const href = `${location.protocol}//${
							location.host.includes("app.yatiku")
								? "inward.yatiku.com"
								: location.host
						}${location.pathname}?${par}&reload=1`;
						// window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${error.appid}&redirect_uri=${encodeURIComponent(href)}&response_type=code&scope=${scopeMode}&state=1#wechat_redirect`);
					}
				);
			}
		} else {
			next();
		}
	});

	sync(store, router);
	const app = new Vue({
		el: "#app",
		store,
		router,
		render: h => h(App)
	});
	return {
		app,
		router,
		store
	};
}



// WEBPACK FOOTER //
// ./src/index.js